import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaBars, FaTimes } from 'react-icons/fa';
import { socialLinks } from '../data';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="navbar">
      <Link to="/" className="logo" onClick={closeMenu}>P. Gjuzelov</Link>
      
      <div className="menu-icon" onClick={toggleMenu}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </div>

      <nav className={`nav-links ${isOpen ? 'active' : ''}`}>
        <a href="/#experience" onClick={closeMenu}>Experience</a>
        <a href="/#projects" onClick={closeMenu}>Work</a>
        <a href="/#education" onClick={closeMenu}>Education</a>
        
        <div className="nav-divider"></div>
        
        <div className="nav-social-icons">
          <a href={socialLinks.github} aria-label="GitHub Profile" target="_blank" rel="noreferrer"><FaGithub /></a>
          <a href={socialLinks.linkedin} aria-label="LinkedIn Profile" target="_blank" rel="noreferrer"><FaLinkedin /></a>
        </div>
        
        <a href={`mailto:${socialLinks.email}`} className="btn-nav" onClick={closeMenu}>Hire Me</a>
      </nav>
    </header>
  );
};

export default Navbar;